<template>
  <div
    class="min-w-[200px] text-nowrap pr-sm"
    :class="{
      'w-full': props.shouldFillColumn,
      'cursor-pointer': props.isSortable,
    }"
    @click="props.isSortable && toggleSortingDirection({ sorting, fieldName: props.fieldName })"
  >
    <div class="flex items-center justify-between gap-4">
      <p v-if="props.text !== ''">
        {{ text }}
      </p>
      <div class="flex">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { GenericTableSchemaFormat } from "../../enum.genericTableSchemaFormat";
import { toggleSortingDirection } from "../../service.genericTableQuery";
import { GenericTableSortingItems } from "../../type.genericTableQuery";

const props = defineProps<{
  text: string;
  shouldFillColumn: boolean;
  fieldName: string;
  format: GenericTableSchemaFormat;
  isSortable: boolean;
}>();
const sorting = defineModel<GenericTableSortingItems>({ required: true });
</script>
